module.exports = __webpack_public_path__ + "static/img/077_TO8_1713_og.aa2d504.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/077_TO8_1713_og.jpg
// module id = hH2d
// module chunks = 0